import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  // Mirrors the "AST Console Revamp" mockup's `.search-form` treatment for this
  // tab (a compact, gapped row rather than fields stretched edge-to-edge) —
  // max-width matches the mockup's own `tab-transactions` search-form.
  rowBox: {
    marginTop: 24,
    flexDirection: 'row',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 24,
    alignItems: 'flex-end',
    maxWidth: 640,
  },
};

export default styles;
